module.exports = __webpack_public_path__ + "static/media/rightArrow.878965c8.svg";